<template>
    <div class="page-logo">
        <img v-if="pageLogo" :alt="wpvue.blogname" :title="wpvue.blogname" :src="pageLogo" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'page-logo',
    props: {
    },
    data(){
        return{
            wpvue : window.WPVUE,
            home : window.WPVUE.home.replace(/\/$/, ""),
        }
    },
    computed:{
        ...mapGetters([
            'getOptions',
        ]),
       pageLogo(){
            const logoDark = (this.getOptions && this.getOptions.logo && this.getOptions.logo.id) ? this.getOptions.logo.url : ''
            return logoDark
        },
    },
    
};
</script>